export const CHECKING_PROMPT_REGISTRY: Record<string, string> = {
  intermodal: 'Checking_Keywords_Intermodal',
  retail: 'Checking_Keywords_Retail',
  easyeom: 'Checking_Keywords_EasyEOM',
};

export const DEFAULT_CHECKING_PROMPT = 'Checking_Keywords_Default';

export function resolveCheckingPrompt(domain?: string): string {
  if (!domain) return DEFAULT_CHECKING_PROMPT;
  return CHECKING_PROMPT_REGISTRY[domain] ?? DEFAULT_CHECKING_PROMPT;
}
